import { Directive, HostListener } from '@angular/core';
import { KeyboardCodes } from '../models/enums/keyboard-codes';

@Directive({ selector: '[appDropdownEvent]' })

export class DropdownEventDirective {
    /** 
     * Dropdown open close actions
     * If clicked outside of dropdown component options will be hidden
     * If clicked within dropdown container options list toggle (open/close)
    **/
    @HostListener('click', ['$event']) public onClick(event:any) {
        const eventAttr = event.target.getAttribute('data-elem');
        if(eventAttr === null){
            this.closeAllDropDown();
            if(event.target?.parentElement?.getAttribute('href') === null || 
                event.target?.getAttribute('href')){
                    event.preventDefault();
                }
        }
        if(eventAttr !== null && eventAttr !== 'dropdownEditable'){
            const dropdownParent = event.target.closest('.dropdown-container');
            const optionSection = dropdownParent?.querySelector('.option-menu-wrapper');
            const isOptionOpened = optionSection?.classList.contains('show-dropdown');
            const dropdownArrowIcon = dropdownParent?.querySelector('.select-dropdown-icon');
            if(isOptionOpened){
                if(event.target?.classList.contains('skip-click')){
                    event.preventDefault();
                }else{
                    optionSection?.classList.remove('show-dropdown');
                    dropdownArrowIcon?.classList.remove('rotate-arrow');
                    if(dropdownParent?.nextElementSibling?.classList.contains('dropdown-error-section')){
                        dropdownParent?.nextElementSibling?.classList.remove('dropdown-error-section');
                    }
                }
            }else{
                this.closeAllDropDown();
                optionSection?.classList.add('show-dropdown');
                dropdownArrowIcon?.classList.add('rotate-arrow');
            }
            
        }
        this.closeActiveTooltip(event);
    }

    @HostListener('keydown', ['$event']) public onKeyDown(event:any) {
        if(event.keyCode === KeyboardCodes.keyEnter){
            const dataElem = event.target.getAttribute('data-elem');
            const tabIdx = event.target.getAttribute('tabIndex');
            if(dataElem !== null && 
                (dataElem=='dropdown'|| dataElem !== 'dropdownEditable') && 
                tabIdx !== null) {
                event.target.click();
            }
        }
    }

    
    public closeAllDropDown(){
        const dropdownOptionSection = document.getElementsByClassName('show-dropdown');
        const dropdownIconElement = document.getElementsByClassName('rotate-arrow');
        if(dropdownOptionSection.length>0){
            for(let i=0; i<dropdownOptionSection.length; i++){
                const parentEl = dropdownOptionSection[i]?.closest('.dropdown-container');
                dropdownOptionSection[i]?.classList.remove('show-dropdown');
                if(parentEl?.nextElementSibling?.classList.contains('dropdown-error-section')){
                    parentEl.nextElementSibling.classList.remove('dropdown-error-section');
                }
            }
        }
        if(dropdownIconElement.length>0){
            for(let i=0; i<dropdownIconElement.length; i++){
                dropdownIconElement[i]?.classList.remove('rotate-arrow');
            }
        }
    }

    public closeActiveTooltip(event: any){
        const dataElem = event.target.getAttribute('data-elem');
        const parentEl = event.target.parentElement?.getAttribute('data-elem')
        if(dataElem !== 'tooltip' && parentEl !== 'tooltip'){
            const activeTooltip = document.getElementsByClassName('tool-tip-active');
            const acitveTooltipContent = document.getElementsByClassName('tooltip-content-active');
            if(activeTooltip.length>0) {
                for(let i=0; i<activeTooltip.length; i++){
                    activeTooltip[i].classList.remove('tool-tip-active');
                }
            }
    
            if(acitveTooltipContent.length>0) {
                for(let i=0; i<acitveTooltipContent.length; i++){
                    acitveTooltipContent[i].classList.remove('tooltip-content-active');
                }
            }
        }
    }
}